import type { DiffViewerProps } from "./diff-viewer.type";

import { highlight, languages } from "prismjs";
import ReactDiffViewerLib, { DiffMethod } from "react-diff-viewer-continued";

import "prismjs/themes/prism.css";

// react-diff-viewer-continued is CJS-only: Rolldown exposes the exports object as the default import,
// so the actual component is nested under `.default`. Fallback for Jest where interop is handled natively.
// TODO Remove when the package ships native ESM.
type DiffViewerType = typeof ReactDiffViewerLib;
const ReactDiffViewer =
  (ReactDiffViewerLib as unknown as { default: DiffViewerType }).default ??
  ReactDiffViewerLib;

export const DiffViewer = (props: DiffViewerProps) => {
  const highlightSyntax = (line: string) => (
    <pre
      style={{ display: "inline" }}
      dangerouslySetInnerHTML={{
        __html: highlight(line, languages.javascript, "json"),
      }}
    />
  );

  return (
    <ReactDiffViewer
      compareMethod={DiffMethod.JSON}
      splitView={false}
      showDiffOnly={false}
      hideLineNumbers={true}
      renderContent={highlightSyntax}
      {...props}
    />
  );
};
